import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import classnames from 'classnames/bind';
import { ColorNames } from '../../../constants/colorVars';
import { getCssColorFromColorName } from '../../../utils/colors';
import Icon from '../icon';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const MobileRibbon = ({ title, iconName, iconColor, icon, className, darkText = false, backgroundColor = ColorNames.Gray, }) => {
    const backgroundColorRaw = getCssColorFromColorName(backgroundColor);
    const foregroundColorRaw = getCssColorFromColorName(darkText ? ColorNames.NearBlack : ColorNames.White);
    const colorStyles = useMemo(() => ({
        backgroundColor: backgroundColorRaw,
        color: foregroundColorRaw,
    }), [backgroundColorRaw, foregroundColorRaw]);
    const _icon = useMemo(() => iconName ? (_jsx(Icon, { name: iconName, color: iconColor || 'inherit', iconStyle: 'solid', fitted: true })) : (icon), [iconName, iconColor, icon]);
    return (_jsxs("div", { className: cx('ribbon', { 'dark-text': darkText }, className), style: colorStyles, children: [_icon && _jsx("div", { className: cx('icon'), children: _icon }), _jsx("div", { children: title })] }));
};
export default MobileRibbon;
//# sourceMappingURL=index.js.map